// src/serviceWorkerRegistration.js
export function register(config) {
    if ('serviceWorker' in navigator) {
      // Only try to register if the file exists at root
      const swUrl = `${process.env.PUBLIC_URL || ''}/service-worker.js`;
  
      window.addEventListener('load', () => {
        fetch(swUrl, { method: 'HEAD' })
          .then((resp) => {
            if (!resp.ok) {
              console.warn('[sw] no service-worker.js found at', swUrl);
              return;
            }
  
            // register
            navigator.serviceWorker
              .register(swUrl)
              .then((registration) => {
                console.log('[sw] registered', registration);
  
                // If there's already a waiting worker, notify
                if (registration.waiting) {
                  config?.onUpdate?.(registration);
                }
  
                registration.onupdatefound = () => {
                  const installing = registration.installing;
                  if (!installing) return;
                  installing.onstatechange = () => {
                    if (installing.state === 'installed') {
                      if (navigator.serviceWorker.controller) {
                        // New update available
                        config?.onUpdate?.(registration);
                      } else {
                        // First install (no existing controller)
                        config?.onSuccess?.(registration);
                      }
                    }
                  };
                };
              })
              .catch((err) => {
                console.error('[sw] registration failed', err);
              });
          })
          .catch((err) => {
            console.warn('[sw] service-worker.js HEAD check failed:', err);
          });
      });
    } else {
      console.warn('[sw] Service Worker not supported');
    }
  }
  